import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export const emptyLearningProgress = {
  completedLessons: {}, lessonPositions: {}, questionAttempts: {}, errorNotebook: {},
  reviewSchedule: {}, introLessons: {}, xp: 0, lastActivity: null
};

export async function loadLearningProgress(uid) {
  const ref = doc(db, 'userProgress', uid);
  const snapshot = await getDoc(ref);
  return snapshot.exists() ? { ...emptyLearningProgress, ...snapshot.data() } : emptyLearningProgress;
}

export async function saveLearningProgress(uid, patch) {
  await setDoc(doc(db, 'userProgress', uid), { ...patch, updatedAt: serverTimestamp() }, { merge: true });
}

export function buildReviewDates(from = new Date()) {
  return [1, 7, 30].map(days => {
    const date = new Date(from);
    date.setDate(date.getDate() + days);
    return { intervalDays: days, dueDate: date.toISOString().slice(0, 10), completed: false };
  });
}
